import { useEffect } from 'react'

const PIXEL_ID = '900170219857277'

let initialized = false

function loadPixelScript() {
  if (initialized) return
  initialized = true

  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  f.fbq('init', PIXEL_ID)
  f.fbq('track', 'PageView')
}

export function trackAddToCart() {
  const fbq = (window as any).fbq
  if (typeof fbq === 'function') {
    fbq('track', 'AddToCart', {
      content_name: 'Plan Antipánico de Deudas',
      content_type: 'product',
      value: 6.36,
      currency: 'USD',
    })
  }
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
  }, [])
}
